<!--
* Provides a claims item summary
*
* @param {string} description - String to be shown as item heading
* @param {number} numberOfImages - Number of images to show as added
* @param {number} numberOfReceipts - Number of receipts to show as added
*
* @fires ClaimsItem#deleteClicked
* @fires ClaimsItem#editClicked
-->

<!--
 * Delete item has been clicked
 *
 * @event ClaimsItem#deleteClicked
 * @property {Event} The click event
-->

<!--
 * Edit item has been clicked
 *
 * @event ClaimsItem#editClicked
 * @property {Event} The click event
-->
<template>
  <div class="damaged-item">
    <!-- item heading -->
    <div
      class="damaged-item-heading"
      @click="toggleOpen">
      <span>{{ description }}</span>
      <span
        class="dropdown-arrow">
        <img
          src="@/assets/theme/images/up-arrow.png"
          v-if="isOpen">
        <img
          src="@/assets/theme/images/down-arrow.png"
          v-if="!isOpen">
      </span>
    </div>
    <!-- Item subtitle -->
    <div class="damaged-item-subtitle" v-if="displaySubtitle">
      <span>{{ numberOfImages }} {{ $t(`${pagei18nKey}.${photoi18nKey}`) }}, {{ numberOfReceipts }} {{ $t(`${pagei18nKey}.${receipti18nKey}`) }}</span>
    </div>
    <!-- item options toggle -->
    <div
      v-if="isOpen"
      class="damaged-item-content">
      <div class="damaged-item-controls">
         <span
           class="delete-control"
           @click="deleteClicked">
        <img
          src="@/assets/theme/images/primary-bin-icon.png"
          class="delete-icon">
        <span>{{ $t(`${pagei18nKey}.deleteItem`) }}</span>
      </span>
        <span
          class="edit-control"
          @click="editClicked">
        <img
          src="@/assets/theme/images/primary-edit-icon.png"
          class="edit-icon">
        <span>{{ $t(`${pagei18nKey}.editItem`) }}</span>
      </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ClaimsItem',
    data: function () {
      return {
        pagei18nKey: 'message.claimsItem',
        isOpen: false,
        photoi18nKey: this.numberOfImages === 1 ? 'photo' : 'photos',
        receipti18nKey: this.numberOfReceipts === 1 ? 'receipt' : 'receipts'
      }
    },

    props: {
      description: {
        type: String,
        required: true
      },

      displaySubtitle: {
        type: Boolean,
        required: true
      },

      numberOfImages: {
        type: Number,
        required: true
      },

      numberOfReceipts: {
        type: Number,
        required: true
      }
    },

    methods: {
      /**
       * Toggle content open state
       */
      toggleOpen: function () {
        this.isOpen = !this.isOpen
      },

      /**
       * emit delete item click event
       * @param {Object} event - Click event
       */
      deleteClicked: function (event) {
        this.$emit('deleteClicked', event)
      },

      /**
       * Emit edit item click event
       * @param {object} event - Click event
       */
      editClicked: function (event) {
        this.$emit('editClicked', event)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/sass/shared.scss";

  $arrow-width: $dims-damaged-item-arrow-width;
  $delete-icon-width: $dims-damaged-item-delete-icon-width;
  $edit-icon-width: $dims-damaged-item-edit-icon-width;

  .damaged-item {
    width: 100%;
  }

  .damaged-item-heading {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-weight: $semibold-font-weight;
    font-size: $large-font-size;
    margin-bottom: $dims-padding-default;
    cursor: pointer;
  }

  .dropdown-arrow {
    width: $arrow-width;
  }

  .damaged-item-subtitle {
    font-size: $medium-font-size;
  }

  .damaged-item-content {
    padding-top: $dims-spacing-large;
    color: $quaternary-text-color;
  }

  .damaged-item-controls {
    display: flex;
  }

  .delete-control,
  .edit-control {
    font-weight: $bold-font-weight;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  .delete-control {
    margin-right: $dims-spacing-small;
  }

  .delete-icon,
  .edit-icon {
    margin-right: $dims-spacing-small;
  }

  .delete-icon {
    width: $dims-damaged-item-delete-icon-width;
  }

  .edit-icon {
    width: $edit-icon-width;
  }
</style>
